import api from '../../api/userAPI';
import {
  setSuccessNotification,
  setErrorNotification
} from '../snackbarNotification';

export const ADD_BEGIN = 'appointmentSlot.ops/ADD_BEGIN';
export const ADD_SUCCESS = 'appointmentSlot.ops/ADD_SUCCESS';
export const ADD_FAILED = 'appointmentSlot.ops/ADD_FAILED';
export const EDIT_BEGIN = 'appointmentSlot.ops/EDIT_BEGIN';
export const EDIT_SUCCESS = 'appointmentSlot.ops/EDIT_SUCCESS';
export const EDIT_FAILED = 'appointmentSlot.ops/EDIT_FAILED';
export const DELETE_BEGIN = 'appointmentSlot.ops/DELETE_BEGIN';
export const DELETE_SUCCESS = 'appointmentSlot.ops/DELETE_SUCCESS';
export const DELETE_FAILED = 'appointmentSlot.ops/DELETE_FAILED';

const addBegin = () => ({ type: ADD_BEGIN });
const addSuccess = () => ({ type: ADD_SUCCESS });
const addFailed = error => ({ type: ADD_FAILED, payload: error });
export const addAppointmentSlot = data => async dispatch => {
  dispatch(addBegin());
  
  const formattedData = {
    start_time: data.startDate,
    end_time: data.endDate,
    doctor_id: data.doctor,
    co_doctor: (data.coDoctor != null) ? data.coDoctor.doctor_id : null,
    booking_type_name: data.appointmentType,
    status: data.status
  };

  console.log(formattedData);

  try {
    const res = await api.post('add-appointment-slot', formattedData);

    dispatch(addSuccess());
    dispatch(setSuccessNotification('Successfully added data'));
  } catch (error) {
    dispatch(addFailed(error.toString()));
    dispatch(setErrorNotification(error.toString()));
  }
};

// const editBegin = () => ({ type: EDIT_BEGIN });
// const editSuccess = () => ({ type: EDIT_SUCCESS });
// const editFailed = error => ({ type: EDIT_FAILED, payload: error });
// export const editAnimalType = (id, data) => async dispatch => {
//   dispatch(editBegin());

//   const formattedData = {
//     id,
//     animal_category: data.category,
//     animal_name: data.name
//   };

//   try {
//     const res = await api.post('update-animal-type', formattedData);

//     dispatch(editSuccess());
//     dispatch(setSuccessNotification('Successfully edited data'));
//   } catch (error) {
//     dispatch(editFailed(error.toString()));
//     dispatch(setErrorNotification(error.toString()));
//   }
// };

const deleteBegin = () => ({ type: DELETE_BEGIN });
const deleteSuccess = () => ({ type: DELETE_SUCCESS });
const deleteFailed = error => ({ type: DELETE_FAILED, payload: error });
export const deleteAppointmentSlot = id => async dispatch => {
  dispatch(deleteBegin());

  const formattedData = {
    appointment_id: id
  };

  try {
    const res = await api.post(`cancel-appointment-slot`, formattedData);

    dispatch(deleteSuccess());
    dispatch(setSuccessNotification('Successfully deleted data'));
  } catch (error) {
    dispatch(deleteFailed(error.toString()));
    dispatch(setErrorNotification(error.toString()));
  }
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case ADD_BEGIN:
    case EDIT_BEGIN:
    case DELETE_BEGIN:
      return { ...state, completed: false, isFetching: true, error: null };

    case ADD_SUCCESS:
    case EDIT_SUCCESS:
    case DELETE_SUCCESS:
      return { ...state, completed: true, isFetching: false };

    case ADD_FAILED:
    case EDIT_FAILED:
    case DELETE_FAILED:
      return { ...state, isFetching: false, error: payload };

    default:
      return state;
  }
};

export default reducer;

const initialState = {
  completed: false,
  isFetching: false,
  error: null
};
